import { render, staticRenderFns } from "./viewCourseware.vue?vue&type=template&id=6375c4ea&scoped=true"
import script from "./viewCourseware.vue?vue&type=script&lang=js"
export * from "./viewCourseware.vue?vue&type=script&lang=js"
import style0 from "./viewCourseware.vue?vue&type=style&index=0&id=6375c4ea&prod&lang=less"
import style1 from "./viewCourseware.vue?vue&type=style&index=1&id=6375c4ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6375c4ea",
  null
  
)

export default component.exports